class CalendarAvailability {
  constructor() {
    this.unavailableDates = [];
    this.lastFetch = null;
    this.cacheTimeout = 1 * 60 * 1000; // 5 minutes
  }

  async fetchUnavailableDates() {
    try {
      // Vérifier le cache
      if (this.lastFetch && Date.now() - this.lastFetch < this.cacheTimeout) {
        return this.unavailableDates;
      }

      const response = await fetch("/api/calendar-availability.php");
      const data = await response.json();

      if (data.success) {
        // CORRECTION : Créer les dates en mode local pour éviter les problèmes de timezone
        this.unavailableDates = (
          typeof data.unavailableDates === "object"
            ? Object.values(data.unavailableDates)
            : data.unavailableDates
        ).map((dateStr) => {
          // Forcer la création d'une date locale à minuit
          const parts = dateStr.split("-");
          const year = parseInt(parts[0]);
          const month = parseInt(parts[1]) - 1; // JavaScript months are 0-indexed
          const day = parseInt(parts[2]);
          return new Date(year, month, day);
        });
        this.lastFetch = Date.now();
      } else {
        console.warn(
          "Calendar API unavailable, falling back to no restrictions",
        );
        this.unavailableDates = [];
      }

      return this.unavailableDates;
    } catch (error) {
      console.error("Failed to fetch calendar availability:", error);
      return [];
    }
  }

  isDateUnavailable(date) {
    // CORRECTION : Normaliser les dates pour la comparaison (ignorer l'heure)
    const normalizeDate = (d) => {
      return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, "0")}-${d.getDate().toString().padStart(2, "0")}`;
    };

    const targetDateStr = normalizeDate(date);
    const isUnavailable = this.unavailableDates.some((unavailableDate) => {
      const unavailableDateStr = normalizeDate(unavailableDate);
      return unavailableDateStr === targetDateStr;
    });

    return isUnavailable;
  }

  /**
   * Trouve la première date indisponible après une date donnée
   * NOUVELLE LOGIQUE : Les dates indisponibles représentent les nuitées réservées
   * @param {Date} fromDate - Date de départ de la recherche
   * @returns {Date|null} - Première date indisponible ou null si aucune
   */
  findFirstUnavailableDateAfter(fromDate) {
    if (!fromDate || this.unavailableDates.length === 0) {
      return null;
    }

    // Normaliser la date de référence à minuit local
    const normalizedFromDate = new Date(
      fromDate.getFullYear(),
      fromDate.getMonth(),
      fromDate.getDate(),
    );

    // Trier les dates indisponibles (nuitées réservées)
    const sortedUnavailableDates = this.unavailableDates
      .filter((date) => {
        const normalizedUnavailableDate = new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
        );
        return normalizedUnavailableDate > normalizedFromDate;
      })
      .sort((a, b) => a - b);

    return sortedUnavailableDates.length > 0 ? sortedUnavailableDates[0] : null;
  }
}

export default CalendarAvailability;
